import PrivateLayout from "@/components/private/PrivateLayout";
import { ADMIN_NAV } from "@/components/private/adminNav";
import { Card } from "@/components/ui/card";
import { trpc } from "@/lib/trpc";
import { Inbox, Mail, Phone } from "lucide-react";

export default function AdminContacts() {
  const { data, isLoading } = trpc.contact.list.useQuery();

  return (
    <PrivateLayout title="Administración" nav={ADMIN_NAV} requireRole="admin">
      <div className="p-6 md:p-12 max-w-6xl">
        <div className="mb-8">
          <h1
            className="font-display font-light text-[var(--forest-deep)] leading-[1.05]"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Mensajes recibidos
          </h1>
          <p className="mt-2 text-sm text-[var(--forest-deep)]/70">
            Formularios de contacto enviados desde la web pública.
          </p>
        </div>

        {isLoading ? (
          <div className="h-64 rounded-xl bg-white/50 animate-pulse" />
        ) : !data || data.length === 0 ? (
          <Card className="p-16 text-center bg-white border border-[var(--forest-deep)]/10">
            <Inbox className="mx-auto text-[var(--forest)]/30 mb-4" size={36} />
            <h2 className="font-display text-2xl font-medium text-[var(--forest-deep)]">
              Aún no hay mensajes
            </h2>
            <p className="mt-2 text-[var(--forest-deep)]/70">
              Los formularios enviados desde la web pública aparecerán aquí.
            </p>
          </Card>
        ) : (
          <div className="space-y-3">
            {data.map((m: any) => (
              <Card
                key={m.id}
                className="p-6 bg-white border border-[var(--forest-deep)]/10"
              >
                <div className="flex flex-wrap items-start justify-between gap-2 mb-3">
                  <div>
                    <div className="font-medium text-[var(--forest-deep)]">
                      {m.name}
                    </div>
                    <div className="flex flex-wrap gap-4 mt-1 text-xs text-[var(--forest-deep)]/70">
                      <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-[var(--forest)]">
                        <Mail size={12} /> {m.email}
                      </a>
                      {m.phone && (
                        <a href={`tel:${m.phone}`} className="flex items-center gap-1 hover:text-[var(--forest)]">
                          <Phone size={12} /> {m.phone}
                        </a>
                      )}
                    </div>
                  </div>
                  <span className="text-xs font-mono text-[var(--forest-deep)]/60">
                    {new Date(m.createdAt).toLocaleString("es-ES")}
                  </span>
                </div>
                {m.subject && (
                  <div className="text-sm font-medium text-[var(--forest-deep)] mb-2">
                    {m.subject}
                  </div>
                )}
                <p className="text-sm text-[var(--forest-deep)]/85 whitespace-pre-wrap leading-relaxed">
                  {m.message}
                </p>
              </Card>
            ))}
          </div>
        )}
      </div>
    </PrivateLayout>
  );
}
